import LoadingSpinner from '@/components/ui/loading-spinner';
import { useSubmission } from '@/hooks/submissions/useSubmission';
import { AlertCircle } from 'lucide-react';
import Status from './Status';
import SiteDetailsCard from './SiteDetailsCard';
import StudyDetailsCard from './StudyDetailsCard';

const Details = ({
  submissionId,
  status,
  submissionType,
  ownerId,
}: {
  submissionId: string;
  status: string;
  submissionType?: 'Study' | 'StudySite' | 'Submission';
  ownerId?: string;
}) => {
  const { submission, isLoading, error } = useSubmission(submissionId!);

  if (isLoading) {
    return (
      <div className="space-y-6 p-6">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-6 p-6">
        <AlertCircle className="mx-auto h-12 w-12 text-red-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">
          Error loading details
        </h3>
        <p className="mt-1 text-sm text-gray-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Status
        status={status}
        submissionId={submissionId}
        subStatusLabel={submission?.sub_status_label}
      />
      {submissionType === 'StudySite' && ownerId ? (
        <SiteDetailsCard siteId={ownerId} />
      ) : (
        submission && <StudyDetailsCard submission={submission} />
      )}
    </div>
  );
};

export default Details;
